/* CrispyCards Cart Drawer V4 — rewards launcher stacking fix.
   Does not intercept Shopify/Impulse quantity or cart operations. */
(() => {
  'use strict';
  if (window.__ccCartPolishV4) return;
  window.__ccCartPolishV4 = true;
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  const targets = new Set();
  const isOpen = () => drawer.classList.contains('drawer--is-open');
  function findLauncher() {
    // Avoid touching cart content. Identify the floating, external rewards trigger only.
    for (const el of document.querySelectorAll('button,a,[role="button"]')) {
      if (drawer.contains(el) || el.closest('header,footer')) continue;
      const t = (el.textContent || '').trim();
      if (!/^(Prämien|Praemien|Rewards)$/i.test(t)) continue;
      const r = el.getBoundingClientRect();
      const s = getComputedStyle(el);
      if (r.width && r.height && (s.position === 'fixed' || el.closest('[style*="position: fixed"], [class*="reward"], [class*="loyalty"]'))) {
        el.classList.add('cc-cart-rewards-behind');
        targets.add(el);
        const parent = el.parentElement;
        if (parent && getComputedStyle(parent).position === 'fixed') {
          parent.classList.add('cc-cart-rewards-behind');
          targets.add(parent);
        }
      }
    }
  }
  let lastOpen = null;
  function sync() {
    const open = isOpen();
    if (open !== lastOpen) {
      lastOpen = open;
      document.documentElement.classList.toggle('cc-cart-open', open);
      if (open) findLauncher();
    }
  }
  const observer = new MutationObserver(sync);
  observer.observe(drawer, {attributes:true, attributeFilter:['class']});
  sync();
  // Rewards apps can insert their floating trigger later.
  const late = new MutationObserver(() => { if (isOpen()) findLauncher(); });
  late.observe(document.body, {childList:true, subtree:false});
  window.addEventListener('pagehide', () => {
    observer.disconnect(); late.disconnect();
    document.documentElement.classList.remove('cc-cart-open');
    targets.forEach(el => el.classList.remove('cc-cart-rewards-behind'));
  }, {once:true});
})();
